export const JWT_TOKEN = "sethala-indoor-jwt-token";
export const CURRENT_USER = "sethala-indoor-current-user";